import React from 'react';
import { Text } from './Text';
import enUS from '../tokens/en-US.json';
import esES from '../tokens/es-ES.json';
import jpJP from '../tokens/jp-JP.json';
import ptBR from '../tokens/pt-BR.json';

export const translations = {
  'en-US': enUS,
  'es-ES': esES,
  'jp-JP': jpJP,
  'pt-BR': ptBR,
};

export const Footer = ({ languageCode, toggleHiddenBuy, toggleHiddenGift, toggleHiddenRequestTransfer }) => (
    <div className="footer-container">
        <div className="footer-item">
            <h4><Text languageCode={languageCode} token="footer.united.header" /></h4>
            <a href={translations[languageCode]["united.home.link.url"]} className="footer-united-link-pcta" target="_blank"><Text languageCode={languageCode} token="footer.united.website" /></a>
            <a href={translations[languageCode]["united.privacy.policy.link.url"]} className="footer-privacy-link-pcta" target="_blank"><Text languageCode={languageCode} token="footer.united.privacy" /></a>
            <a href={translations[languageCode]["mileageplus.program.rules.link.url"]} className="footer-rules-link-pcta" target="_blank"><Text languageCode={languageCode} token="footer.united.rules" /></a>
        </div>
        <div className="footer-item">
            <h4><Text languageCode={languageCode} token="footer.buy.header" /></h4>
            <a className="footer-buy-link-pcta" onClick={ toggleHiddenBuy } href=""><Text languageCode={languageCode} token="footer.buy.buy" /></a>
            <a className="footer-gift-link-pcta" onClick={ toggleHiddenGift } href=""><Text className="footer-gift-link-pcta" languageCode={languageCode} token="footer.buy.gift" /></a>
        </div>
        <div className="footer-item">
            <h4><Text languageCode={languageCode} token="footer.transfer.header" /></h4>
            <a className="footer-transfer-link-pcta"  href={translations[languageCode]["transfer.link.url"]} ><Text languageCode={languageCode} token="footer.transfer.transfer" /></a>
            <a className="footer-request-transfer-link-pcta" onClick={ toggleHiddenRequestTransfer } target="_blank" href=""><Text languageCode={languageCode} token="footer.transfer.request" /></a>
        </div>

    </div>
);